import type { TenantSelection } from '../../../contexts/tenantSelection';

/** Backend-Sentinel für `GET /api/admin/tenants/customer-assignments?tenantId=`, liefert Kunden ohne Tenant. */
export const UNASSIGNED_TENANT_FILTER = 'unassigned';

/** Anzeigename für Kunden ohne Tenant — optisch abgesetzt (kursiv/grau) in Filter und Tabelle. */
export const UNASSIGNED_TENANT_LABEL = '<unzugeordnet>';

/**
 * Quell-Filter der Seite "Kunden-Zuordnung" — immer genau EINE Quelle, nie
 * "Alle Tenants". Zusätzlich zu echten Tenants gibt es die feste Pseudo-Quelle
 * "Kunden ohne Tenant" (nur auf dieser Seite, nicht im globalen Header-Filter).
 */
export type AssignmentSourceFilter = { kind: 'tenant'; tenant: TenantSelection } | { kind: 'unassigned' };

/**
 * Wandelt den Quell-Filter in den `tenantId`-Query-Parameter der Zuordnungsliste um.
 * @param filter Aktueller Quell-Filter.
 * @returns Tenant-UUID oder der Sentinel {@link UNASSIGNED_TENANT_FILTER}.
 */
export function sourceFilterToTenantIdParam(filter: AssignmentSourceFilter): string {
  return filter.kind === 'unassigned' ? UNASSIGNED_TENANT_FILTER : filter.tenant.id;
}

/**
 * Anzeigename des Quell-Filters für die Picker-Trigger-Beschriftung.
 * @param filter Aktueller Quell-Filter.
 */
export function sourceFilterLabel(filter: AssignmentSourceFilter): string {
  return filter.kind === 'unassigned' ? UNASSIGNED_TENANT_LABEL : filter.tenant.name;
}

/**
 * Anzeigename für die Spalte "Aktueller Tenant" in der Kundentabelle.
 * @param tenantName Tenantname aus `AdminTenantAssignmentCustomer.tenantName`; null = kein Tenant.
 */
export function currentTenantLabel(tenantName: string | null): string {
  return tenantName ?? UNASSIGNED_TENANT_LABEL;
}
